import React, { useContext } from "react";
import { BrowserRouter, Routes, Route, withRouter } from "react-router-dom";

import Home from "./Pages/Home/Home";
import PrivacyPolicy from "./Pages/PrivacyPolicy/PrivacyPolicy";
import RefundPolicy from "./Pages/RefundPolicy/RefundPolicy";
import GrievancePolicy from "./Pages/GrievancePolicy/GrievancePolicy";
import TermsAndConditions from "./Pages/TermsAndConditions/TermsAndConditions";
import ContactUs from "./Pages/ContactUs/ContactUs";
import AboutUs from "./Pages/AboutUs/AboutUs";

import LoadingContext from "./Store/loading-context";
import Loading from "./Pages/Loading/Loading";
import Industries from "./Pages/Industries/Industries";
import Technology from "./Pages/Technology/Technology";
import TechnologyDigitalSolutions from "./Pages/Services/TechnologyDigitalSolutions";
import PaymentsEGovernance from "./Pages/Services/PaymentsEGovernance";
import ScrollToTop from "./ScrollToTop";

const App = () => {
  const loadingCtx = useContext(LoadingContext);

  return (
    <React.Fragment>
      {loadingCtx.isLoading && <Loading />}

      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="about-us" element={<AboutUs />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="refund-policy" element={<RefundPolicy />} />
          <Route path="grievance-policy" element={<GrievancePolicy />} />
          <Route path="terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="contact-us" element={<ContactUs />} />
          <Route path="ppi-tnc" element={<ContactUs />} />

          <Route path="industries" element={<Industries />} />
          <Route path="technology" element={<Technology />} />
          <Route
            path="/technology-digital-solutions"
            element={<TechnologyDigitalSolutions />}
          />

          <Route
            path="/payments-e-governance"
            element={<PaymentsEGovernance />}
          />
        </Routes>
      </BrowserRouter>
    </React.Fragment>
  );
};

export default App;
